export const SIDEBAR_LAYOUT = {
  rail: 64,
  menuPanel: 270,
  contextPanel: 380,
  ticketListColumn: 340,
  convMin: 460,
  mobileBreak: 900,
};

// leftOpen e rightOpen nunca ficam true ao mesmo tempo (mutuamente exclusivos,
// ver SidebarContext), então cada modo é calculado de forma independente.
export function computeSidebarModes({ width, contentionEnabled, leftOpen, rightOpen }) {
  const { rail, menuPanel, contextPanel, ticketListColumn, convMin, mobileBreak } = SIDEBAR_LAYOUT;

  if (width < mobileBreak) {
    return { leftMode: "drawer", rightMode: "drawer" };
  }

  if (!contentionEnabled) {
    return { leftMode: "push", rightMode: "push" };
  }

  const rest = width - rail * 2 - ticketListColumn;
  const menuExtra = menuPanel - rail;
  const contextExtra = contextPanel - rail;

  const leftMode = !leftOpen || rest - menuExtra >= convMin ? "push" : "overlay";
  const rightMode = !rightOpen || rest - contextExtra >= convMin ? "push" : "overlay";

  return { leftMode, rightMode };
}
